(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@price-point/configuration", [], factory);
	else if(typeof exports === 'object')
		exports["@price-point/configuration"] = factory();
	else
		root["@price-point/configuration"] = factory();
})(global, function() {
return 